import { ServiceClient } from 'src/utils'
import { RegraRow } from './regra.types'

const serviceClient = ServiceClient.singleton()

export class RegraService {
    static #INSTANCE = new RegraService()
    static readonly singleton = () => RegraService.#INSTANCE

    async fetchRegraInfo(analiseId: number, id: number) {
        return serviceClient.authGet<RegraRow>(`/api/v1/analise/${analiseId}/regra/${id}`)
    }

    async fetchRegras(analiseId: number) {
        return serviceClient.authGet<RegraRow[]>(`/api/v1/analise/${analiseId}/regra`)
    }

    async saveRegra(analiseId: number, regra: RegraRow) {
        const response = await serviceClient.authPost<RegraRow>(`/api/v1/analise/${analiseId}/regra`, regra)
        return response
    }

    async updateRegra(analiseId: number, idRegra: number, regra: RegraRow) {
        const response = await serviceClient.authPut<RegraRow>(`/api/v1/analise/${analiseId}/regra/${idRegra}`, regra)
        return response
    }

    async deleteRegra(analiseId: number, id: number) {
        const response = await serviceClient.authDelete(`/api/v1/analise/${analiseId}/regra/${id}`)
        return response
    }
}

export default RegraService.singleton()
